// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.description-text {
  padding-left: 10px;
}

input, textarea {
  font-size: 13px !important;
  border-radius: 0 !important;
  background: #FDFDFD !important;
  border: 1px solid #EAEAEA !important;
  box-sizing: border-box !important;
  width: 99.3%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
